import classNames from "classnames";
import _ from "lodash";

import { swSettings } from "app/common/services/swSettings";

import * as Cells from "./cells";
import { DefaultCell } from "./cells/DefaultCell";
import * as HeaderCells from "./headerCells";
import { DefaultCellHeader } from "./headerCells/DefaultCellHeader";

function toComponentName(templateName: string) {
    if (templateName) {
        // @ts-ignore FIXME: strict migration - regex match may return null — legacy code assumes template name always matches the pattern
        return templateName.match(/([^/]+?)\.htm/)[1].replace(/(.+?)(-|\b)/gi, (_all: string, match1: string) => {
            return match1[0].toUpperCase() + match1.slice(1);
        });
    }
}

function getCellComponent(column: FixmeType) {
    if (typeof column.cellComponent === "function") {
        return column.cellComponent;
    }
    if (column?.cellComponent?.displayName) {
        return column.cellComponent;
    }
    const cellComponentName = toComponentName(column.cellTemplate || "");
    // @ts-ignore FIXME: strict migration - dynamic indexing of barrel re-export — Cells is a namespace import, runtime lookup by computed name
    const cellComponent = Cells[cellComponentName] || Cells[cellComponentName + "Cell"];
    if (!cellComponent) {
        return DefaultCell;
    }
    return cellComponent;
}

function getHeaderCellComponent(column: FixmeType) {
    if (typeof column.headerComponent === "function") {
        return column.headerComponent;
    }
    if (column?.headerComponent?.displayName) {
        return column.headerComponent;
    }
    const headerComponentName = toComponentName(column.headerCellTemplate || "");
    // @ts-ignore FIXME: strict migration - dynamic indexing of barrel re-export — HeaderCells is a namespace import, runtime lookup by computed name
    const headerCell = HeaderCells[headerComponentName];
    if (!headerCell) {
        return DefaultCellHeader;
    }
    return headerCell;
}

export function decorateColumn(
    column: FixmeType,
    tableOptions: FixmeType,
    resizedCols: FixmeType,
    isLast?: boolean | null,
) {
    const COL_MIN_WIDTH = 40;
    const sortDirection = column.inverted && column.sortDirection ? toggleDirection(column) : column.sortDirection,
        headerSortClass = classNames(
            column.sortable ? "is-sortable" : "",
            column.isSorted ? "is-sorted sortDirection--" + sortDirection : "",
        );
    const isNarrowColumn = (parseInt(column.width) || parseInt(column.minWidth)) < COL_MIN_WIDTH;
    const isResizableColumn = column.isResizable !== undefined ? column.isResizable : !isLast && !isNarrowColumn;

    const resizedWidth =
        resizedCols && resizedCols[column.field] > 0
            ? {
                  width: resizedCols[column.field],
                  minWidth: null,
                  maxWidth: null,
              }
            : {};

    return Object.assign(
        {},
        column,
        {
            columnClass: classNames(column.columnClass, {
                "swReactTable-column": isResizableColumn,
                "swReactTable-unResizeColumn": !isResizableColumn,
            }),
            isSortedClass: column.sortable && column.isSorted ? "is-sorted" : "",
            headerCellClass: classNames({
                ["swReactTableHeaderCell swTable-headerCell"]: true,
                ...(column.headerCellClass ? { [column.headerCellClass]: true } : {}),
                ...(headerSortClass ? { [headerSortClass]: true } : {}),
                ["u-force-hide"]: tableOptions.hideHeader,
                ["nohover"]: column.disableHeaderCellHover,
            }),
            cellClass: classNames(column.cellClass, "swReactTableCell", "swTable-cell", {
                "resizeableCell-hover": isResizableColumn,
            }),
            width: _.includes(column.width, "%") ? column.width : parseInt(column.width),
            minWidth: _.includes(column.minWidth, "%") ? column.minWidth : parseInt(column.minWidth),
            maxWidth: _.includes(column.maxWidth, "%") ? column.maxWidth : parseInt(column.maxWidth),
            CellComponent: getCellComponent(column),
            HeaderComponent: getHeaderCellComponent(column),
        },
        resizedWidth,
    );
}

export function setColumnWidth(isBigTable: boolean, col: FixmeType, isLast?: boolean) {
    const style: React.CSSProperties = {};
    if (col.width && (col.minWidth || col.maxWidth)) {
        // console.error("col.width && col.minWidth both have values");
    }
    if (col.width) {
        style.flexShrink = 0;
        style.flexGrow = 0;
        style.flexBasis = col.width;
    } else {
        if (col.minWidth) {
            style.flexGrow = 1;
            style.flexShrink = !isBigTable ? 0 : style.flexShrink;
            style.flexBasis = col.minWidth;
        }
        if (col.maxWidth) {
            style.flexGrow = 1;
            style.maxWidth = col.maxWidth;
        }
    }

    if (isBigTable) {
        // fixed columns do not grow
        if (col.fixed) {
            style.flexGrow = 0;
        }
        // last columns must grow
        if (isLast && !col.lastColumnFixed) {
            style.flexGrow = 1;
            style.maxWidth = undefined;
        }
    }

    return style;
}

export function toggleDirection(col: FixmeType) {
    return col.sortDirection.toLowerCase() === "asc" ? "desc" : "asc";
}

export function getTableMetadata(
    tableData: Record<PropertyKey, unknown> | undefined,
    hasChilds: boolean,
    totalCount: number | undefined,
    tableMetadata: Record<PropertyKey, unknown> = {},
) {
    return {
        ...tableMetadata,
        totalCount,
        minCellValue: tableData?.minCellValue,
        maxCellValue: tableData?.maxCellValue,
        page: tableData?.page,
        pageSize: tableData?.pageSize,
        upgradeUrl: swSettings.swurls.UpgradeAccountURL,
        hasChilds,
        Header: tableData?.Header,
    };
}

export const paddingRightCell = {
    field: "paddingRightCell",
    displayName: "",
    type: "string",
    format: "None",
    sortable: false,
    isSorted: false,
    cellComponent: () => "",
    headerComponent: DefaultCellHeader,
    sortDirection: "desc",
    tooltip: "",
    visible: true,
};
